import axios from "../../../axios";

export const getWorkers = async () => {
  try {
    let { data } = await axios.get(`/v1/worker`);
    return data;
  } catch (e) {
    console.log("error while getting workers", e);
  }
};
